import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PointsSummaryState } from './points-summary.reducer';

export const getPointsSummaryFeatureState =
  createFeatureSelector<PointsSummaryState>('pointsSummary');

export const getPointsSummary = createSelector(
  getPointsSummaryFeatureState,
  (s) => s.pointsSummary,
);

export const getPointsSummaryBalance = createSelector(
  getPointsSummaryFeatureState,
  (s) => (s.pointsSummary ? s.pointsSummary.pointsBalance : 0),
);

export const getPointsSummaryLoading = createSelector(
  getPointsSummaryFeatureState,
  (s) => s.loading,
);

export const getPointsSummaryError = createSelector(
  getPointsSummaryFeatureState,
  (s) => s.error,
);
